import { useEffect, useRef, useState } from "react";
import "./style.css";

const AdminInputLuggage = ({
  type = "text",
  prefixIcon = null,
  suffixIcon = null,
  placeholder = "",
  mb = "mb-3",
  label = null,
  totalCabin,
  totalCheckin,
  onChange,
  value,
}) => {
  const [openPanel, setOpenPanel] = useState(false);
  const handleInputOnClick = () => {
    setOpenPanel(!openPanel);
  };
  const panelRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setOpenPanel(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className={`${mb} position-relative`}>
        {label && <label className="tw:!mb-1 tw:!text-[15px] tw:!text-[#8D8D8D]">{label}</label>}
        <div className="w-100 rounded border">
          <div className="tw:flex! tw:justify-center! tw:items-center! d-flex gap-2 input-container">
            {prefixIcon && (
              <span className="ms-3">{prefixIcon}</span>
            )}
            <input
              className={`
                tw:border-none 
                tw:outline-none 
                tw:w-full 
                tw:!leading-[32px] 
                tw:rounded 
                tw:border-0 
                tw:py-2 
                tw:!text-[15px] 
                tw:!font-['Hanken_Grotesk'] 
                tw:placeholder:!text-[15px] 
                tw:placeholder:!font-['Hanken_Grotesk'] 
                tw:cursor-pointer 
                no-calendar 
                ${prefixIcon != null ? "" : "px-3"}
              `}
              type={type}
              readOnly={true}
              placeholder={placeholder}
              onClick={handleInputOnClick}
              value={value}
            />
            {suffixIcon && (
              <span className="me-3">{suffixIcon}</span>
            )}
          </div>
        </div>
        {openPanel && (
          <div className="border rounded mt-2" ref={panelRef} style={{
            position: "absolute",
            backgroundColor: "white",
            zIndex: 1000,
            overflow: "auto",
            border: "1px solid #ddd",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            width: "100%"
          }}>
            <div className="d-flex gap-3 border-bottom p-3 justify-content-between align-items-center">
              <p className="m-0">Cabin Size <br /> (approx. 55 x 40 x 20cm)</p>
              <div className="d-flex gap-4 align-items-center">
                <button
                  type="button"
                  className="btn btn-circle btn-outline-dark"
                  onClick={() => onChange("cabin", -1)}
                >
                  <i className="bi bi-dash d-flex align-items-center justify-content-center"></i>
                </button>
                <p className="m-0">{totalCabin}</p>
                <button
                  type="button"
                  className="btn btn-circle btn-outline-dark"
                  onClick={() => onChange("cabin", 1)}
                >
                  <i className="bi bi-plus d-flex align-items-center justify-content-center"></i>
                </button>
              </div>
            </div>
            <div className="d-flex gap-3 border-bottom p-3 justify-content-between align-items-center">
              <p className="m-0">Check-in Size <br /> (approx. 80 x 50 x 30 cm)</p>
              <div className="d-flex gap-4 align-items-center">
                <button
                  type="button"
                  className="btn btn-circle btn-outline-dark"
                  onClick={() => onChange("checkin", -1)}
                >
                  <i className="bi bi-dash d-flex align-items-center justify-content-center"></i>
                </button>
                <p className="m-0">{totalCheckin}</p>
                <button
                  type="button"
                  className="btn btn-circle btn-outline-dark"
                  onClick={() => onChange("checkin", 1)}
                >
                  <i className="bi bi-plus d-flex align-items-center justify-content-center"></i>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AdminInputLuggage;
